import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "label"]

  connect() {
    this.lockedCheckbox = null
    this.updateLockState()
    this.setupFormSubmit()
  }

  setupFormSubmit() {
    const form = this.element.closest('form')
    if (form) {
      form.addEventListener('submit', () => {
        if (this.lockedCheckbox) {
          this.lockedCheckbox.disabled = false
        }
      })
    }
  }

  updateLockState() {
    const checkedBoxes = this.checkboxTargets.filter(cb => cb.checked)

    if (this.lockedCheckbox) {
      this.unlockCheckbox(this.lockedCheckbox)
    }

    if (checkedBoxes.length === 1) {
      this.lockCheckbox(checkedBoxes[0])
    } else {
      this.lockedCheckbox = null
    }
  }

  toggle(event) {
    const checkbox = event.currentTarget

    if (checkbox === this.lockedCheckbox) {
      event.preventDefault()
      checkbox.checked = true
      return
    }

    this.updateLockState()
  }

  lockCheckbox(checkbox) {
    this.lockedCheckbox = checkbox
    checkbox.disabled = true

    const label = checkbox.closest('label')
    if (label) {
      label.classList.add('opacity-60', 'cursor-not-allowed')
      label.classList.remove('hover:bg-gray-50')

      let indicator = label.querySelector('.locked-indicator')
      if (!indicator) {
        indicator = document.createElement('span')
        indicator.className = 'locked-indicator ml-2 text-xs text-gray-500 italic'
        indicator.textContent = '(Required)'
        label.appendChild(indicator)
      }
    }
  }

  unlockCheckbox(checkbox) {
    checkbox.disabled = false

    const label = checkbox.closest('label')
    if (label) {
      label.classList.remove('opacity-60', 'cursor-not-allowed')
      label.classList.add('hover:bg-gray-50')

      const indicator = label.querySelector('.locked-indicator')
      if (indicator) {
        indicator.remove()
      }
    }
  }
}
